import { render, staticRenderFns } from "./LeadGeneration.vue?vue&type=template&id=52b5808f"
import script from "./LeadGeneration.vue?vue&type=script&lang=js"
export * from "./LeadGeneration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports